export const SelfServeCourseMessage = {
    enrollNow: {
        key: 'selfServeCourse.labelsAndTitles.ENROLL_NOW'
    },
    notNow: {
        key: 'selfServeCourse.labelsAndTitles.NOT_NOW'
    },
    selfServeCourseHeading: {
        key: 'selfServeCourse.labelsAndTitles.SELF_SERVE_COURSE_HEADING'
    },
    selfServeCourseDesc: {
        key: 'selfServeCourse.labelsAndTitles.SELF_SERVE_COURSE_DESC'
    },
    courseLocked: {
        key: 'selfServeCourse.labelsAndTitles.COURSE_LOCKED'
    },
    enrollNowPopupMsg: {
        key: 'selfServeCourse.labelsAndTitles.ENROLL_NOW_POPUP_MSG'
    },
    enrollNowPopupDesc: {
        key: 'selfServeCourse.labelsAndTitles.ENROLL_NOW_POPUP_DESC'
    },
    successFullyEnrolled: {
        key: 'selfServeCourse.labelsAndTitles.SUCCESSFULLY_ENROLLED'
    },
    successFullyEnrolledMsg1: {
        key: 'selfServeCourse.labelsAndTitles.SUCCESSFULLY_ENROLLED_MSG1'
    },
    successFullyEnrolledMsg2: {
        key: 'selfServeCourse.labelsAndTitles.SUCCESSFULLY_ENROLLED_MSG2'
    },
    successFullyEnrolledMsg3: {
        key: 'selfServeCourse.labelsAndTitles.SUCCESSFULLY_ENROLLED_MSG3'
    },
    successFullyEnrolledMsg4: {
        key: 'selfServeCourse.labelsAndTitles.SUCCESSFULLY_ENROLLED_MSG4'
    },
    enrollConfirmationHeading: {
        key: 'selfServeCourse.labelsAndTitles.ENROLL_CONFIRMATION_POPUP_HEADING'
    },
    enrollConfirmationDesc: {
        key: 'selfServeCourse.labelsAndTitles.ENROLL_CONFIRMATION_POPUP_DESC'
    }
};
